document.addEventListener("algolia.hooks.initialize", () => {

  const staticHtml = [
   {symbol:'<svg width="15" height="13" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 16.875L15 3.125C15 2.43464 14.4404 1.875 13.75 1.875L6.25 1.875C5.55964 1.875 5 2.43464 5 3.125L5 16.875C5 17.5654 5.55964 18.125 6.25 18.125H13.75C14.4404 18.125 15 17.5654 15 16.875Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 5.625C10.5178 5.625 10.9375 5.20527 10.9375 4.6875C10.9375 4.16973 10.5178 3.75 10 3.75C9.48223 3.75 9.0625 4.16973 9.0625 4.6875C9.0625 5.20527 9.48223 5.625 10 5.625Z" fill="currentColor"></path></svg>',
            label: "Talk to an expert", url: "tel:+61297730122"},
    {symbol:'',label: "Contact Support", url: "/pages/contact-us"},
    {symbol:'',label: "Browse Technical Guides", url: "/blogs/learning-hub"},
    {symbol:'',label: "View Articles", url: "/pages/faq"}
  ];
  const staticKeywords = [
    { label: "Bush", url: "/search?q=bush" },
    { label: "m10x", url: "/search?q=m10+x" },
    { label: "Vent", url: "/search?q=vent" },
    { label: "Loctite", url: "/search?q=loctite" },
    { label: "Sutton", url: "/search?q=sutton" },
    { label: "Fuel", url: "/search?q=fuel" },
    { label: "CRC", url: "/search?q=crc" }
  ];

  const categories = [
    { label: "Clearance Sale", url: "/collections/clearance-sale" },
    { label: "New Arrivals", url: "/collections/new-arrivals" },
    { label: "On Sale", url: "/collections/on-sale" },
    { label: "Promotions", url: "/pages/promotions" },
    { label: "Shop By Category", url: "/collections/shop-by-category" }
  ];

  const brands = [
    { label: "Champion", url: "/collections/champion" },
    { label: "Recoil", url: "/collections/recoil" },
    { label: "View All Brands", url: "/collections/shop-by-brand" }
  ];

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteConfigurationOptions",
    (config, context) => {
      config.queries = config.queries.map((queryObj) => {
        const q = queryObj.query || "";
        const normalized = q.replace(/(\d+)x(\d+)/gi, "$1 x $2");
        //if (normalized !== q) {
          //console.log("Query transformed:", q, "→", normalized);
        //}
        return {
          ...queryObj,
          query: normalized,
        };
      });
      return config;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteNoResultsTemplate",
    (_defaultTemplate, templateOptions) => {
      const { html, state } = templateOptions;
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <p class="aa-NoResultsHeader">
            ${algoliaShopify.translation_helpers.no_result_for(state.query)}
          </p>
        <div class="aa-PanelSections">
          <div class="aa-PanelSection aa-PanelSection--left">
            <div class="aa-NoResultsBlock">
              <div class="aa-SourceHeader"><span class="aa-SourceHeaderTitle">Suggested Searches</span><div class="aa-SourceHeaderLine"></div></div>
              <ul class="aa-List" role="listbox">
              ${staticKeywords.map(
                item => html`
                  <li class="aa-Item" role="option" aria-selected="false"><a href="${item.url}" class="aa-ItemLink aa-NoResultsLink">
                    ${item.label}
                  </a></li>
                `
              )}
              </ul>
          </div>
          <div class="aa-NoResultsBlock">
            <div class="aa-SourceHeader"><span class="aa-SourceHeaderTitle">Brands</span><div class="aa-SourceHeaderLine"></div></div>
            <ul class="aa-List" role="listbox">
            ${brands.map(
              item => html`
                <li class="aa-Item" role="option" aria-selected="false"><a href="${item.url}" class="aa-NoResultsLink">
                  ${item.label}
                </a></li>
              `
            )}
            </ul>
          </div>
          </div>
          <div class="aa-PanelSection aa-PanelSection--right">
          <div class="aa-NoResultsBlock">
            <div class="aa-SourceHeader"><span class="aa-SourceHeaderTitle">Couldn't find your product?</span><div class="aa-SourceHeaderLine"></div></div>
            <ul class="aa-List" role="listbox">
            ${staticHtml.map(
              item => html`
                <li class="aa-Item" role="option" aria-selected="false"><a href="${item.url}" class="aa-ItemLink aa-NoResultsLink">
                  ${item.symbol ? html([item.symbol]) : ""}<span>${item.label}</span>
                </a></li>
              `
            )}
            </ul>
          </div>
          <div class="aa-NoResultsBlock">
            <div class="aa-SourceHeader"><span class="aa-SourceHeaderTitle">Categories</span><div class="aa-SourceHeaderLine"></div></div>
            <ul class="aa-List" role="listbox">
            ${categories.map(
              item => html`
                <li class="aa-Item" role="option" aria-selected="false"><a href="${item.url}" class="aa-ItemLink aa-NoResultsLink">
                  ${item.label}
                </a></li>
              `
            )}
            </ul>
          </div>
</div></div>
          <div class="aa-SourceFooter"><div class="aa-footer">
            <a class="aa-SeeAllBtn aa-NoResultsLink" href="${window.Shopify.routes.root}search">${algoliaShopify.translations.allProducts}</a>
          </div></div>
        </div>
      `;
    }
  );
});


/* ------------------------------------------------------------------
   AIMS - retain the search term in the header search box
   Added 16/09/26. Raised by Uros: the header box went blank once the
   results page loaded, so people had to retype the whole search just
   to change one word.

   Seeds the Autocomplete input from the ?q= parameter, so on a results
   page the box shows what was searched and can be edited in place.
   Only runs when ?q= is present, so the homepage, collection pages and
   product pages keep the normal placeholder.

   To remove: delete this whole block.
------------------------------------------------------------------ */
document.addEventListener("algolia.hooks.initialize", () => {

  const currentQuery = (new URLSearchParams(window.location.search).get("q") || "").trim();
  if (!currentQuery) return;

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    (options) => ({
      ...options,
      initialState: {
        ...(options.initialState || {}),
        query: currentQuery
      }
    })
  );
});